import { render, staticRenderFns } from "./VideoShowModal.vue?vue&type=template&id=829361e4&scoped=true&"
import script from "./VideoShowModal.vue?vue&type=script&lang=js&"
export * from "./VideoShowModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoShowModal.vue?vue&type=style&index=0&id=829361e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829361e4",
  null
  
)

export default component.exports